import style from "modules/PsyProfile/components/Info/components/Location/style.module.scss"
import { renderCityWithDetails } from "utils/helpers/psychologistUtil"
import { Icon } from "components"
import { getAvailableLocations } from "utils/helpers"
import { Psychologist } from "utils/interfaces"
import { Text } from "ui-kit/components-branded/Text"

export const Location = ({ psy }: { psy: Psychologist }) => {
    const availableLocations = getAvailableLocations(psy)

    return (
        <div data-testid="psy-profile-location">
            <Text className={style.location}>Принимает {availableLocations}</Text>
            <div className={style.city}>
                <Icon type="nav" color="blue-3" size={24} className={style.cityIcon} />
                <Text>{renderCityWithDetails(psy.new_city.name, psy.city_details)}</Text>
            </div>
        </div>
    )
}
